function AppendChevron({ node }) {
	log({ node }, typeof node);
	// example title
	const title = node.innerHTML;
	// turn the title into an array
	const titleArr = title.trim().split(' ');
	// get the last word for attaching with the icon
	const lastWord = titleArr.pop();

	const restOfTitle = titleArr.join(' ');

	log(restOfTitle); // "This is a"
	log(lastWord); // "title"

	const chevron =
		'<svg class="ml-[0.4em] inline-block w-[0.45em] -mt-[0.2em]  || icon " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.65 23.77"><path fill="currentColor" d="M1.77 23.77 0 22l10.12-10.12L0 1.77 1.77 0l11.88 11.88L1.77 23.77z"/></svg>';

	let html = `<div>${
		restOfTitle.length > 0 ? `<span>${restOfTitle}</span> ` : ''
	}${`<span class="whitespace-nowrap">${lastWord}${chevron}</span>`}</div>`;

	node.innerHTML = html;
}

export default AppendChevron;
